export const Options = {
    AreaOfDeployment: [
        { text:"Bauträger",value:"Bauträger"},
        { text:"Bauunternehmen/Bauhof",value:"Bauunternehmen/Bauhof"},
        { text:"Haus- und Grundstücksverwaltung",value:"Haus- und Grundstücksverwaltung"},
        { text:"Wohnungsunternehmen",value:"Wohnungsunternehmen"},
        { text:"Verwaltungsbereiche",value:"Verwaltungsbereiche"},
    ],
    SalaryRequest: [
        { text:"bis 30.000 €",value:"bis 30.000 €"},
        { text:"bis 40.000 €",value:"bis 40.000 €"},
        { text:"bis 50.000 €",value:"bis 50.000 €"},
        { text:"bis 60.000 €",value:"bis 60.000 €"},
        { text:"bis 70.000 €",value:"bis 70.000 €"},
        { text:"ab 70.000 €",value:"ab 70.000 €"},
    ],
    BecomingAwareThrough: [
        { text:"Gundlach Homepage",value:"Gundlach Homepage"},
        { text:"Persönliche Empfehlung",value:"Persönliche Empfehlung"},
        { text:"Stepstone",value:"Stepstone"},
        { text:"Xing",value:"Xing"},
        { text:"LinkedIn",value:"LinkedIn"},
        { text:"Sonstiges",value:"Sonstiges"},
    ]
}
